import { Component, inject } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ModalableWhiteboardDrawing } from '../../../models/modalable-whiteboard-drawing';
import { ModalService } from '../../../services/modal.service';
import { PageService } from '../../../services/page.service';
import { WhiteboardTipComponent } from './whiteboard-tip/whiteboard-tip.component';
import { WhiteboardDrawingsListComponent } from './whiteboard-drawings-list/whiteboard-drawings-list.component';
import { CrudService } from '../../../services/crud.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';

declare let MediaRecorder: any;

@Component({
    selector: 'app-whiteboard-drawing-content',
    templateUrl: './whiteboard-drawing-content.component.html',
    styleUrls: ['./whiteboard-drawing-content.component.scss'],
    standalone: true,
    imports: [
        WhiteboardTipComponent,
        WhiteboardDrawingsListComponent
    ]
})
export class WhiteboardDrawingContentComponent {
    whiteboardDrawing: ModalableWhiteboardDrawing;
    crudService = inject(CrudService);

    constructor(
        public applicationStateService: ApplicationStateService,
        public pageService: PageService,
        public modalService: ModalService) {
    }

    onClick(): void {
        if (!this.canBeIntialized()) {
            alert('MediaRecorder is not supported by this browser.');
        } else {
            this.whiteboardDrawing = new ModalableWhiteboardDrawing();
            this.modalService.openModal(this.whiteboardDrawing);
            this.crudService.logDirect(TechnicalFeature.Whiteboard);
        }
    }

    limitedView(): boolean {
        return !this.pageService.hasLimitedView() ||
            !this.whiteboardDrawing.asWhiteboardDrawing().page_id ||
            (
                this.pageService.hasLimitedView() &&
                this.pageService.getGetViewablePagesIDs().includes(this.whiteboardDrawing.asWhiteboardDrawing().page_id)
            );
    }

    private canBeIntialized(): boolean {
        const stream = new MediaStream();
        let options: any = { mimeType: 'video/webm' };
        // @ts-ignore
        let mediaRecorder: any = {};

        try {
            mediaRecorder = new MediaRecorder(stream, options);
        } catch (e0) {
            try {
                options = { mimeType: 'video/webm,codecs=vp9', contentType: 'video/webm' };
                mediaRecorder = new MediaRecorder(stream, options);
            } catch (e1) {
                try {
                    options = 'video/vp8';
                    mediaRecorder = new MediaRecorder(stream, options);
                } catch (e2) {
                    mediaRecorder = {};

                    return false;
                }
            }
        }
        mediaRecorder = {};

        return true;
    }
}
